import { makeStyles } from '@material-ui/core';
import { variables } from 'components/Theme';
import React from 'react';
import useWidth from 'v2/hooks/useWidth';

const useStyles = makeStyles((theme) => ({
  tBody: {
    color: variables.palette.primary.light,
    fontSize: theme.typography.fontSize,
    fontWeight: 400,
  },
}));

interface IProps {
  children: React.ReactNode;
}

const MyTableBody = ({ children }: IProps) => {
  const width = useWidth();
  const classes = useStyles({});
  if (width === 'md' || width === 'lg' || width === 'xl') {
    return <tbody className={classes.tBody}>{children}</tbody>;
  }

  return <div className={classes.tBody}>{children}</div>;
};

export default MyTableBody;
